import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useTheme } from 'styled-components';
import { BookIcon } from '../assets';
import Input from '../input/Input';
import { useModal } from '../modal';
import Toggle from '../toggle/Toggle';
import Typography from '../typography/Typography';
import NewAddressContent from './NewAddressContent';
import AddressOptionsContent from './AddressOptionsContent';
import { ChooseAddressWrapper, SaveAddressText, SelectAddressText, TrButton, Wrapper, } from './styles';
const SaveOrChooseAddress = ({ value, options, checked, saveText, buttonTitle, rightComponent, disclaimerText, disabled = false, selectedOptionId, inputPlaceholder, optionsModalTitle, saveAddressModalTitle, isValueInSavedAddresses, onOptionSelection, valueValidator, onButtonClick, setChecked, onChange, onBlur, inputErrorMessage, setSaveAddressClicked, shouldToggleBeDisabled, setAddressName, chooseAddressText, maxLengthErrText, alreadyExistText, inputPlaceHolder, }) => {
    const { colors } = useTheme();
    const { Dialog, openModal, closeModal } = useModal();
    const { Dialog: OptionsModal, openModal: openOptionsModal, closeModal: closeOptionModal, } = useModal();
    const openSaveAddressModal = () => {
        if (checked) {
            setChecked(false);
            setAddressName?.('');
        }
        else if (value.length > 0) {
            if (valueValidator) {
                const isValid = valueValidator(value);
                if (!isValid)
                    return;
            }
            openModal();
            setSaveAddressClicked && setSaveAddressClicked(true);
        }
    };
    const handleSaveAddress = (addressName) => {
        closeModal();
        onButtonClick?.(addressName);
    };
    const handleInputChange = (e) => {
        const { value, name } = e.target;
        onChange?.({
            ...e,
            target: {
                ...e.target,
                name,
                value: value.replace(/\s/g, ''),
            },
        });
    };
    const isAddressFromBook = !!options?.find((opt) => opt.title === value);
    const shouldEnableChoosing = (value.length < 1 || disabled) && options?.length;
    return (_jsxs(Wrapper, { children: [_jsx(Input, { value: value, rightComponent: rightComponent, onBlur: onBlur, disabled: disabled, onChange: handleInputChange, placeholder: inputPlaceholder, errorMessage: inputErrorMessage }), _jsx(ChooseAddressWrapper, { children: shouldEnableChoosing || isAddressFromBook ? (_jsxs(_Fragment, { children: [_jsx(Typography, { type: "caption", children: chooseAddressText }), _jsxs(TrButton, { onClick: openOptionsModal, children: [_jsx(BookIcon, {}), _jsx(SelectAddressText, { type: "caption", fontFamily: "primaryBold", color: colors.interactive.brandColor, children: optionsModalTitle })] })] })) : (_jsxs(_Fragment, { children: [_jsx(Toggle, { disabled: shouldToggleBeDisabled, labelSize: "1.6rem", checked: checked, onChangeValue: openSaveAddressModal }), _jsx(SaveAddressText, { type: "caption", children: saveText })] })) }), !!options?.length && (_jsx(OptionsModal, { title: optionsModalTitle, children: _jsx(AddressOptionsContent, { options: options, selectedOptionId: selectedOptionId, onOptionSelection: onOptionSelection, closeModal: closeOptionModal }) })), _jsx(Dialog, { title: saveAddressModalTitle, children: _jsx(NewAddressContent, { value: value, buttonTitle: buttonTitle, disclaimerText: disclaimerText, inputPlaceholder: inputPlaceholder, isValueInSavedAddresses: isValueInSavedAddresses, onButtonClick: handleSaveAddress, setChecked: setChecked, maxLengthErrText: maxLengthErrText, alreadyExistText: alreadyExistText, inputPlaceHolder: inputPlaceHolder }) })] }));
};
export default SaveOrChooseAddress;
//# sourceMappingURL=SaveOrChooseAddress.js.map